const TermsOfUse = () => {
  return (
    <div className="!py-4 text-white">
      <div className="container">
        <div>
          <p
            style={{
              lineHeight: '108%',
              textAlign: 'right',
              background: 'transparent',
              marginBottom: '0.11in',
            }}
          >
            <br />
            &nbsp;
          </p>
          <p
            style={{
              lineHeight: '108%',
              textAlign: 'center',
              background: 'transparent',
              marginBottom: '0.11in',
            }}
          >
            <u>
              <strong>TUTOR TERMS &amp; CONDITIONS</strong>
            </u>
          </p>
          <p
            style={{
              lineHeight: '108%',
              textAlign: 'justify',
              background: 'transparent',
              marginBottom: '0.11in',
            }}
          >
            This document (hereinafter referred to as&nbsp;<strong>“Agreement”</strong>), the Terms
            of Use (Terms of Use) and Privacy Policy (Privacy Policy) as amended from time to time
            on the basis of the Agreement&nbsp;<strong>BETWEEN</strong> you, the tutor, (hereinafter
            referred to as&nbsp;<strong>“Tutor”</strong>)&nbsp;<strong>AND</strong>{' '}
            <strong>APOLO LDA&nbsp;</strong>(hereinafter referred to as&nbsp;
            <strong>“Platform”</strong> or<strong>&nbsp;“site”</strong>).&nbsp;
          </p>
          <p
            style={{
              lineHeight: '108%',
              textAlign: 'justify',
              background: 'transparent',
              marginBottom: '0.11in',
            }}
          >
            In this Agreement, the Tutor and the Platform may individually be referred to as a&nbsp;
            <strong>Party</strong> and together as&nbsp;<strong>Parties</strong>.
          </p>
          <p
            style={{
              lineHeight: '108%',
              textAlign: 'justify',
              background: 'transparent',
              marginBottom: '0.11in',
            }}
          >
            This document, the Terms of Use and the Privacy Policy together referred to as&nbsp;
            <strong>Terms</strong>.
          </p>
          <p
            style={{
              lineHeight: '108%',
              textAlign: 'left',
              marginBottom: '0.11in',
              background: 'transparent',
            }}
          >
            <span lang="en-GB">
              <strong>BACKGROUND</strong>
            </span>
          </p>
          <ol type="A">
            <li value={1}>
              <p
                style={{
                  textAlign: 'justify',
                  marginBottom: '0.08in',
                  background: 'transparent',
                  lineHeight: '100%',
                }}
              >
                The Platform has developed a marketplace to connect tutors, (hereinafter referred to
                as <strong>“Tutors”</strong>) who wish to sell their services (
                <strong>Services</strong>) to potential students (<strong>Students</strong>).&nbsp;
              </p>
            </li>
            <li>
              <p
                style={{
                  textAlign: 'justify',
                  marginBottom: '0.08in',
                  background: 'transparent',
                  lineHeight: '100%',
                }}
              >
                The Tutor is a Tutor and wishes to promote and sell its Services on the
                Platform.&nbsp;
              </p>
            </li>
            <li>
              <p
                style={{
                  textAlign: 'justify',
                  marginBottom: '0.08in',
                  background: 'transparent',
                  lineHeight: '100%',
                }}
              >
                The Platform wishes to permit the Tutor to sell its Services on the Platform subject
                to the Terms set out herein.
              </p>
            </li>
          </ol>
          <p
            style={{
              textAlign: 'justify',
              marginBottom: '0.08in',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.5in',
            }}
          >
            <br />
            &nbsp;
          </p>
          <ol>
            <li>
              <p
                style={{
                  lineHeight: '108%',
                  textAlign: 'left',
                  marginBottom: '0.11in',
                  background: 'transparent',
                }}
              >
                <strong>I</strong>
                <span lang="en-GB">
                  <strong>NTERPRETATION&nbsp;</strong>
                </span>
              </p>
            </li>
          </ol>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            <span>The following rules of interpretation apply in this Agreement:</span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            1.1<span>Headings shall not affect the interpretation of this agreement.</span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            1.2
            <span>
              A person includes an individual, corporate or unincorporated body (whether or not
              having separate legal personality).&nbsp;
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            1.3
            <span>
              A reference to a company shall include any company, corporation or other body
              corporate, wherever and however incorporated or established.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            1.4
            <span>
              Unless the context otherwise requires, words in the singular shall include the plural
              and in the plural shall include the singular.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            1.5
            <span>
              Unless the context otherwise requires, a reference to one gender shall include a
              reference to the other genders.&nbsp;
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            1.6
            <span>
              References to ‘including’ or similar shall be construed to mean ‘including but not
              limited to’.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            1.7<span>References to clauses are to the clauses of this agreement.</span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            1.8
            <span>
              The word ‘written’ shall include writing in electronic form and ‘signed’ shall include
              electronic signature or any other electronic communication which signifies the
              sender’s or originator’s intention to be bound by such electronic communication.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              marginLeft: '1.38in',
            }}
          >
            <br />
            &nbsp;
          </h2>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            2.LICENSE AND USE OF THE PLATFORM&nbsp;
          </h1>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            2.1
            <span>
              Subject to the compliance with the Terms, the Platform hereby grants the Tutor a
              non-exclusive, non-transferable right to use the Platform solely for the sale of the
              Tutor’s Services in accordance with the Terms.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            2.2
            <span>
              The Platform reserves the right to refuse to list any Services on the Platform or to
              remove any listing of Services in its absolute discretion, without giving a reason.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            2.3
            <span>
              The Platform shall provide services to the Tutor to sell its Services and shall use
              reasonable endeavours to provide the Tutor with assistance as is reasonably necessary
              to facilitate the provision of Services by the Tutor.&nbsp;
            </span>
          </h2>
          <h1
            style={{
              lineHeight: '115%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0.22in',
              marginBottom: '0in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            3.SUPPORT SERVICES&nbsp;
          </h1>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            3.1
            <span>
              The Platform may, as part of the services provided under this Agreement, provide the
              Tutor with additional support services (
            </span>
            <span>
              <strong>Support Services</strong>
            </span>
            <span>), including:&nbsp;</span>
          </h2>
          <h4
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (i)Dashboard – The Platform will provide the Tutor with a daily report on sales,
            statistics, earnings etc.
          </h4>
          <h4
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (ii)Marketing &amp; Advertising – The Platform will make all reasonable efforts to
            assist the Tutor with the marketing and may from time to time, invite the Tutor to
            participate in marketing and promotional activities, which may include, but is not
            limited to, promotion discounts, advertising, free samples, contents, logos. The costs
            of such marketing shall be apportioned between the Platform and the Tutor as determined
            by the Platform in its sole and absolute discretion.&nbsp;
          </h4>
          <h4
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (iii)Customer Service – The Platform will provide a facility for Students to lodge
            complaints, comments and enquiries regarding Services. The Platform may provide the
            Tutor with the details of all Student Correspondence received by the Platform in order
            to facilitate for the Tutor to respond to the Student Correspondence in a timely
            fashion.&nbsp;
          </h4>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0.22in',
              marginBottom: '0in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            4.TUTOR OBLIGATIONS&nbsp;
          </h1>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            4.1<span>As a Tutor:</span>
          </h2>
          <h4
            style={{
              lineHeight: '0.21in',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (i)you will provide the tutoring services in accordance with these Terms and other
            policies set forth by APOLO and made available to you via email or by posting on the
            Website;
          </h4>
          <h4
            style={{
              lineHeight: '0.21in',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (ii)you will provide the tutoring services in accordance with laws and regulations
            applicable in the state or country where you are providing the tutoring services;
          </h4>
          <h4
            style={{
              lineHeight: '0.21in',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (iii)you are solely responsible and fully liable for any violation of any local laws and
            regulations that apply to your provision of the tutoring services;
          </h4>
          <h4
            style={{
              lineHeight: '0.21in',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (iv)you will provide the tutoring services with reasonable care and skill and in
            accordance with generally recognized practices;
          </h4>
          <h4
            style={{
              lineHeight: '0.21in',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (v)you will not provide tutoring services to the Students outside of the APOLO Platform,
            receive payments from the Students directly, or encourage or solicit payment from the
            Student directly or through any channels other than those provided by APOLO;
          </h4>
          <h4
            style={{
              lineHeight: '0.21in',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (vi)you acknowledge and agree that APOLO may advertise tutoring services that you
            provide via the APOLO Platform without any additional payment or obligation to
            you;&nbsp;
          </h4>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            4.2
            <span>
              If the Tutor is in breach of the Terms in any manner, the Platform may without notice
              block the Tutor’s access to the Platform, and/or remove any offending content from the
              Platform.&nbsp;
            </span>
          </h2>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            5.FULFILMENT &amp; DELIVERY
          </h1>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            5.1
            <span>
              The Tutor shall ensure the proper fulfilment and delivery of all Services made on the
              Platform, while the Platform shall only be in charge of the processing of such orders.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            5.2
            <span>
              The Tutor shall: (a) Cooperate with Students in all matters relating to the Services
              and provide such materials and/or information as may be required by Students for the
              purposes of carrying out the Services in a timely manner and ensure that such
              materials or information are complete and accurate; (b) Respond promptly to Student
              requests to provide direction, information (c) Obtain and maintain all necessary
              licenses and consents and comply with all applicable laws in relation to Platform
              services before the date on which the Services are to commence.
            </span>
          </h2>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            6.CHARGES AND PAYMENT
          </h1>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            6.1
            <span>
              The Tutor shall pay a commission at the rates below, calculated as a percentage of the
              total cost of the Services charged to the Students; the percentage shall be based on
              the weekly hours taught by the Tutor, as follows:&nbsp;
            </span>
          </h2>
          <ul>
            <ul>
              <li>
                <h2
                  style={{
                    lineHeight: '100%',
                    textAlign: 'justify',
                    marginTop: '0in',
                    marginBottom: '0.08in',
                    background: 'transparent',
                    fontFamily: '"Times New Roman", serif',
                  }}
                >
                  <span>0-14 hours taught by the Tutor in the last 7 days – 18%</span>
                </h2>
              </li>
              <li>
                <h2
                  style={{
                    lineHeight: '100%',
                    textAlign: 'justify',
                    marginTop: '0in',
                    marginBottom: '0.08in',
                    background: 'transparent',
                    fontFamily: '"Times New Roman", serif',
                  }}
                >
                  <span>15-24 hours taught by the Tutor in the last 7 days – 14%</span>
                </h2>
              </li>
              <li>
                <h2
                  style={{
                    lineHeight: '100%',
                    textAlign: 'justify',
                    marginTop: '0in',
                    marginBottom: '0.08in',
                    background: 'transparent',
                    fontFamily: '"Times New Roman", serif',
                  }}
                >
                  <span>25-40 hours taught by the Tutor in the last 7 days – 10%</span>
                </h2>
              </li>
            </ul>
          </ul>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            6.2
            <span>
              The Platform will notify the Tutor in the case of adding or changing such fees at
              least 5
            </span>
            <span style={{ color: 'rgb(255, 0, 0)' }}>&nbsp;</span>
            <span>working days in advance.&nbsp;</span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            6.3
            <span>
              The Commission will be debited from the amount collected by the Platform from the
              Student.&nbsp;
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            6.4
            <span>
              If there is a dispute in relation to the Services, then the Tutor acknowledges that
              payment under clause may be delayed until such date that the dispute has been resolved
              to the satisfaction of the Parties and the Student.&nbsp;
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            6.5
            <span>
              The Platform has the right to deduct any Commission and any other amounts payable by
              the Tutor, whether under this Agreement or otherwise, owed to it from any amounts owed
              to the Tutor, including from any future sales made on the Platform.&nbsp;
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            6.6
            <span>
              The Platform shall be entitled at its sole discretion, to increase the Commission and
              other charges from time to time, by giving at least&nbsp;
            </span>
            <span style={{ color: 'rgb(255, 0, 0)' }}>7&nbsp;</span>
            <span>days’ notice to the Tutor.&nbsp;</span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            6.7<span>The Platform reserves the right to revise the fees structure.&nbsp;</span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            6.8
            <span>
              The Tutor authorises the Platform to use online payment methods and the Tutor shall be
              responsible for all expenses and commissions applied by the banks for using such
              service.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              marginLeft: '1.38in',
            }}
          >
            <br />
            &nbsp;
          </h2>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            7.CONTRACT WITH STUDENT
          </h1>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            7.1
            <span>
              The Tutor contracts with the relevant Student in respect of purchases of Services made
              via the Platform, and not with the Platform.&nbsp;
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            7.2
            <span>
              Whilst the Platform checks the identity of Students, the Platform does not accept
              responsibility or liability for their default.
            </span>
          </h2>
          <h1
            style={{
              lineHeight: '0.21in',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0.22in',
              marginBottom: '0in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            8.PROMOTION, DISPLAY, PUBLICITY
          </h1>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0.19in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            8.1
            <span>
              APOLO may issue any promotion, advertisement, announcement, press release,
              communication, public declaration or any content related to the Tutor without the
              prior written approval of the Tutor.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0.19in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            8.2
            <span>
              Neither Party will perform any actions that will harm the other party’s name and
              reputation.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0.19in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            8.3
            <span>
              Neither Party shall use the name or Intellectual Property Rights of the other Party
              without the prior written consent of the other Party.
            </span>
          </h2>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            9.DATA PROTECTION AND USE&nbsp;
          </h1>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            9.1
            <span>
              Each Party shall comply with all applicable laws and the Terms in relation to the
              privacy and security of any personal data to which it gains access in the course of
              using the Platform (
            </span>
            <span>
              <strong>Data</strong>
            </span>
            <span>).&nbsp;</span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            9.2
            <span>
              The Tutor must not use the Data to market to, or otherwise contact the Students except
              as necessary to fulfil orders placed or enquiries made through the Platform. For the
              avoidance of doubt, this shall not prevent the Tutor from dealing with Students with
              whom it was in contact prior to any contact made through the Platform.&nbsp;
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            9.3
            <span>
              Each Party shall take appropriate technical and organisational measures against
              unauthorised or unlawful processing of the Data or its accidental loss, destruction or
              damage.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              marginLeft: '1.38in',
            }}
          >
            <br />
            &nbsp;
          </h2>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            10.CONFIDENTIALITY&nbsp;<span lang="en-US">AND NON-CIRCUMVENTION</span>
          </h1>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            10.1
            <span>
              Either Party may be given access to information relating the business or personal of
              the other Party in order to perform its obligations under this Agreement (
            </span>
            <span>
              <strong>Confidential Information</strong>
            </span>
            <span>
              ). A Party's Confidential Information shall not be deemed to include information that:
            </span>
          </h2>
          <h4
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (i)is or becomes publicly known other than through any act or omission of the receiving
            Party;
          </h4>
          <h4
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (ii)was in the other Party's lawful possession before the disclosure;
          </h4>
          <h4
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (iii)is lawfully disclosed to the receiving Party by a third party without restriction
            on disclosure;
          </h4>
          <h4
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (iv)is independently developed by the receiving Party, which independent development can
            be shown by written evidence; or
          </h4>
          <h4
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (v)is required to be disclosed by law, by any court of competent jurisdiction or by any
            regulatory or administrative body having jurisdiction over the receiving Party.
          </h4>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            10.2
            <span>
              Each Party shall hold the other's Confidential Information in confidence and not make
              the other's Confidential Information available to any third party or use the other's
              Confidential Information for any purpose other than the implementation of this
              Agreement.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            10.3
            <span>
              Each Party shall take all reasonable steps to ensure that the other's Confidential
              Information to which it has access is not disclosed or distributed by its employees or
              agents in violation of the terms of this Agreement.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            10.4
            <span>
              The Tutor hereby agrees that the Platform may introduce (whether by written, oral,
              data, or other form of communication) the Tutor to one or more opportunities,
              including, without limitation, natural persons, corporations, limited liability
              companies, partnerships, unincorporated businesses, sole proprietorships, and similar
              entities (hereinafter an “Opportunity” or “Opportunities”). The Tutor further
              acknowledges and agrees that the identity of the subject Opportunities, and all other
              information concerning an Opportunity (including without limitation, all mailing
              information, phone and fax, numbers, email addresses and other contact information)
              introduced hereunder are the property of the Platform, and shall be treated as
              confidential and proprietary information by the Tutor, its affiliates, officers,
              directors, shareholders, employees, agents, representatives, successors and assigns.
              The Tutor shall not use such information, except in the context of any arrangements
              with the Platform in which the Platform is directly and actively involved, and never
              without the Platform’s prior written approval. The Tutor further agrees that neither
              it nor its employees, affiliates or assigns, shall enter into, or otherwise arrange
              (either for it/him/herself, or any other person or entity) any business relationship,
              contact any person regarding such Opportunity, either directly or indirectly, or any
              of its affiliates, or accept any compensation or advantage in relation to such
              Opportunity except as directly through the Platform, without prior written approval of
              the Platform. The Platform is relying on the Tutor’s assent to these terms and their
              intent to be bound by the terms by evidence of their signature. Without the Tutor’s
              assigned assent to these terms, the Platform would not introduce any Opportunity or
              disclose any confidential information to the Tutor as herein described.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              marginLeft: '1.38in',
            }}
          >
            <br />
            &nbsp;
          </h2>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            11.LIABILITY AND INDEMNITY&nbsp;
          </h1>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            11.1
            <span>
              The Tutor shall defend, indemnify and hold harmless the Platform against all claims,
              actions, proceedings, losses, damages, expenses and costs (including court costs and
              legal fees) arising out of or in connection with:&nbsp;
            </span>
          </h2>
          <h4
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (i)the Tutor’s supply of the Services;&nbsp;
          </h4>
          <h4
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (ii)the Tutor’s use of the Platform;&nbsp;
          </h4>
          <h4
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (iii)the Tutor’s breach of any of the Terms; or
          </h4>
          <h4
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            (iv)any claim that any content added by the Tutor to the Platform or any Services
            supplied infringe the intellectual property rights of a third party.&nbsp;
          </h4>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              marginLeft: '1.37in',
              textIndent: '-0.5in',
            }}
          >
            11.2
            <span>
              The Platform’s liability to the Tutor shall, save in case of fraud or wilful
              misconduct, be limited to the amount of Commission paid in the six-month period
              leading up to the event giving rise to the liability.&nbsp;
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              marginLeft: '1.37in',
              textIndent: '-0.5in',
            }}
          >
            11.3
            <span>
              The Platform shall not be liable in any way for any damage that might occur as a
              result of any defect that occurs on the Platform due to any circumstances pertaining
              and not limited to any occurring Force Majeure, breakdown of the connectivity, or
              hacking.
            </span>
          </h2>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            12.CONFLICT
          </h1>
          <p
            style={{
              textAlign: 'justify',
              marginBottom: '0.08in',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.5in',
            }}
          >
            If there is an inconsistency between any of the Terms, the following order of priority
            shall apply: this Agreement, the Terms of Use, the Privacy Policy.
          </p>
          <p
            style={{
              textAlign: 'justify',
              marginBottom: '0.08in',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.5in',
            }}
          >
            <br />
            &nbsp;
          </p>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            13.NO WAIVER
          </h1>
          <p
            style={{
              textAlign: 'justify',
              marginBottom: '0.08in',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.5in',
            }}
          >
            No failure or delay by a Party to exercise any right or remedy provided under the Terms
            or by law shall constitute a waiver of that or any other right or remedy, nor shall it
            prevent or restrict the further exercise of that or any other right or remedy. No single
            or partial exercise of such right or remedy shall prevent or restrict the further
            exercise of that or any other right or remedy.
          </p>
          <p
            style={{
              textAlign: 'justify',
              marginBottom: '0.08in',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.5in',
            }}
          >
            <br />
            &nbsp;
          </p>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            14.RIGHTS AND REMEDIES
          </h1>
          <p
            style={{
              textAlign: 'justify',
              marginBottom: '0.08in',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.5in',
            }}
          >
            Except as expressly provided in this Agreement, the rights and remedies provided under
            this Agreement are in addition to, and not exclusive of, any rights or remedies provided
            by law.
          </p>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            15.SEVERABILITY
          </h1>
          <p
            style={{
              lineHeight: '108%',
              textAlign: 'justify',
              background: 'transparent',
              marginLeft: '0.5in',
              marginBottom: '0.11in',
            }}
          >
            If any provision of these Terms shall be found by any court or administrative body of
            competent jurisdiction to be invalid or unenforceable, the invalidity or
            unenforceability of such provision shall not affect the other provisions of these Terms,
            and all provisions not affected by such invalidity or unenforceability shall remain in
            full force and effect. Such provision will be changed and interpreted to accomplish the
            objectives of the provision to the greatest extent possible under Applicable Laws.
          </p>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            16.ENTIRE AGREEMENT
          </h1>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            16.1
            <span>
              The Terms, and any documents referred to in them, constitute the whole agreement
              between the Parties and supersede any previous arrangement, understanding or agreement
              between them relating to the subject matter they cover.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            16.2
            <span>
              Each of the Parties acknowledges and agrees that in entering into this Agreement it
              does not rely on any undertaking, promise, assurance, statement, representation,
              warranty or understanding (whether in writing or not) of any person (whether party to
              this agreement or not) relating to the subject matter of this Agreement, other than as
              expressly set out in the Terms.
            </span>
          </h2>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            17.INTELLECTUAL PROPERTY RIGHTS AND DATA
          </h1>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            17.1
            <span>
              Any and all intellectual property rights created by the Platform on behalf of the
              Tutor shall vest in the Platform and the Tutor hereby assigns all rights, title and
              interests to the Platform in all such intellectual property rights.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            17.2
            <span>
              The Tutor grants to the Platform a fully paid-up, non-exclusive, transferable,
              perpetual and irrevocable license to use, reproduce and maintain any material owned by
              the Tutor to comply with its obligations under this Agreement.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            17.3
            <span>
              The Tutor shall not use without the prior written consent of the Platform any data or
              intellectual property rights of the Platform or related to and/or arising from this
              Agreement.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              marginLeft: '1.37in',
              textIndent: '-0.5in',
            }}
          >
            17.4
            <span>
              All data provided by or on behalf of the Platform to the Tutor, or developed by or on
              behalf of the Platform and the Tutor, in connection the offering of the Services
              through the Platform shall be the exclusive property of the Platform, and the Tutor
              may not purchase, deliver or release data provided by or on behalf of the Platform or
              developed under this Agreement in any way without the prior written approval of the
              Platform.
            </span>
          </h2>
          <h2
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              marginLeft: '1.37in',
              textIndent: '-0.5in',
            }}
          >
            17.5
            <span>
              The Tutor must promptly provide all data produced by or on behalf of the Tutor in
              connection with this Agreement to the Platform upon request.&nbsp;
            </span>
          </h2>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            18.NO PARTNERSHIP OR AGENCY
          </h1>
          <p
            style={{
              textAlign: 'justify',
              marginBottom: '0.08in',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.5in',
            }}
          >
            Nothing in this agreement is intended to or shall operate to create a partnership
            between the Parties, or authorise either Party to act as agent for the other, and
            neither Party shall have the authority to act in the name or on behalf of or otherwise
            to bind the other in any way (including the making of any representation or warranty,
            the assumption of any obligation or liability and the exercise of any right or power).
          </p>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            19.NOTICES&nbsp;
          </h1>
          <p
            style={{
              textAlign: 'justify',
              marginBottom: '0.08in',
              background: 'transparent',
              lineHeight: '100%',
              marginLeft: '0.5in',
            }}
          >
            Any notice given in connection with the Terms shall be delivered via the Platform,
            unless the Tutor’s access to the<span style={{ color: 'rgb(255, 0, 0)' }}>&nbsp;</span>e
            Platform has been withdrawn, in which case the Platform may send notices to the Tutor
            using the contact details set out in this Agreement, and the Tutor may send notices to
            the Platform at&nbsp;EMAIL. The Platform may serve notices under this Agreement by way
            of a general announcement made via the Platform.&nbsp;
          </p>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            20.LIMITATION OF LIABILITY
          </h1>
          <p
            style={{
              lineHeight: '108%',
              textAlign: 'justify',
              background: 'transparent',
              marginLeft: '0.49in',
              textIndent: '-0.49in',
              marginBottom: '0.11in',
            }}
          >
            To the maximum extent permissible by applicable law, Platform, its parents,
            subsidiaries, affiliates, and their respective suppliers, and any of their owners,
            officers, directors, managers, members, agents, and employees:
          </p>
          <ol type="a">
            <li>
              <p
                style={{
                  textAlign: 'justify',
                  background: 'transparent',
                  lineHeight: '115%',
                  marginBottom: '0.14in',
                }}
              >
                are not liable for any direct, indirect, punitive, incidental, special, or
                consequential damages or loss arising out of, or in a way connected with the use or
                inability to use the Platform and its content, whether based on warranty, contract,
                tort (including negligence), or any other legal theory, and whether or not Platform
                is advised of the possibility of such damages; and
              </p>
            </li>
            <li>
              <p
                style={{
                  textAlign: 'justify',
                  background: 'transparent',
                  lineHeight: '115%',
                  marginBottom: '0.14in',
                }}
              >
                exclude any and all liability for damages caused by, any problems or technical
                malfunction of any telephone network or lines, computer online systems, servers or
                providers, computer equipment, software, failure of any communications due to
                technical problems or traffic congestion on the Internet or on the Platform or
                combination thereof, including any injury or damage to any users or to any person’s
                computer related to or resulting from use of the Platform.
              </p>
            </li>
          </ol>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            21.FURTHER ASSURANCE
          </h1>
          <p
            style={{
              lineHeight: '108%',
              textAlign: 'justify',
              background: 'transparent',
              marginLeft: '0.5in',
              marginBottom: '0.11in',
            }}
          >
            Each Party shall co-operate with the other Party and execute and deliver and take such
            other actions as may be reasonably requested from time to time in order to carry out,
            evidence and confirm their rights hereunder and the intended purpose of this Agreement
            and to ensure the complete and prompt fulfillment, observance and performance of the
            provisions of this Agreement and generally that full effect is given to the provisions
            of this Agreement.
          </p>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            22.GOVERNING LAW.&nbsp;
          </h1>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
            }}
          >
            <span lang="en-US">
              <span style={{ fontWeight: 'normal' }}>
                These Terms and any non-contractual rights or obligations arising out of or in
                connection with it shall be governed by and construed in accordance with the laws of
                Portugal.
              </span>
            </span>
          </h1>
          <h1
            style={{
              lineHeight: '100%',
              textAlign: 'justify',
              marginLeft: '0.5in',
              marginTop: '0in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
              fontWeight: 'bold',
              textIndent: '-0.5in',
            }}
          >
            23.DISPUTE RESOLUTION:
          </h1>
          <h2
            style={{
              lineHeight: '0.21in',
              textAlign: 'justify',
              marginTop: '0.19in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            23.1Any dispute which arises between the Parties shall be attempted to be resolved by
            good faith discussions between the Parties.
          </h2>
          <h2
            style={{
              lineHeight: '0.21in',
              textAlign: 'justify',
              marginTop: '0.19in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            23.2Where the Parties are unable to resolve such disputes by good faith discussions
            within a period of thirty (30) business days from the date of a written notice by either
            Party notifying existence of such dispute, either Party shall be free to refer the
            dispute to arbitration in accordance with this Section.&nbsp;
          </h2>
          <h2
            style={{
              lineHeight: '0.21in',
              textAlign: 'justify',
              marginTop: '0.19in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            23.3This Agreement and the rights and obligations of the Parties shall remain in full
            force and effect pending the award in such arbitration proceeding.
          </h2>
          <h2
            style={{
              lineHeight: '0.21in',
              textAlign: 'justify',
              marginTop: '0.19in',
              marginBottom: '0.08in',
              background: 'transparent',
              fontFamily: '"Times New Roman", serif',
            }}
          >
            23.4Any disputes or claims arising out of or in connection with these Terms of Use,
            including any non-contractual rights or obligations arising out of or in connection with
            these Terms shall be referred to and finally resolved by the courts having jurisdiction
            at the Platform’s headquarters.
          </h2>
          <p style={{ lineHeight: '100%', textAlign: 'left', marginBottom: '0in' }}>
            <br />
          </p>
        </div>
      </div>
    </div>
  )
}

export default TermsOfUse
